var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnknown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "Unknown_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FB5D2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A83A6",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 0l16 16v26.4a5.6 5.6 0 01-5.6 5.6H9.6A5.6 5.6 0 014 42.4V5.6A5.6 5.6 0 019.6 0H28z",
    fill: "url(#Unknown_svg__a)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    fillRule: "nonzero",
    x: 22,
    y: 27.267,
    width: 15.333,
    height: 1.533,
    rx: 0.767
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    fillRule: "nonzero",
    x: 22,
    y: 22.667,
    width: 15.333,
    height: 1.533,
    rx: 0.767
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    fillRule: "nonzero",
    x: 10,
    y: 33.2,
    width: 27.333,
    height: 1.533,
    rx: 0.767
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    fillRule: "nonzero",
    x: 10,
    y: 37.8,
    width: 18.667,
    height: 1.533,
    rx: 0.767
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 16H33.883C30.79 16 28 13.21 28 10.117V0l16 16z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 16H33.883C30.79 16 28 13.21 28 10.117V0l16 16z",
    fill: "#BDCADD"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#FFF",
    strokeWidth: 2,
    x: 10.667,
    y: 21.333,
    width: 8,
    height: 7.333,
    rx: 1
  }))));
}
export default SvgUnknown;